import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteFirm, setDeleteFirmId} from "../../actions/firms";

const FirmDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_firm, currentPage, numberOfPages, firms} = useSelector(state => state.firm);

    const closeModal = () =>{
        // removing firm user from redux state by sending null setDeleteFirmId
        dispatch(setDeleteFirmId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage == numberOfPages) && (firms.length == 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteFirm(delete_firm.id, getPage))
    };

    let condition = false;
    if(delete_firm !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Firmani o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu firmani o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default FirmDeleteForm;